var _a;
import { Prior_Authorization_Status_Requester } from 'generated/types';
import { enumValuesFactory } from 'utils/objectHelper';
var enumDescriptionMap = (_a = {},
    _a[Prior_Authorization_Status_Requester.Cmm] = 'CMM',
    _a[Prior_Authorization_Status_Requester.Member] = 'Member',
    _a[Prior_Authorization_Status_Requester.Manufacturer] = 'Manufacturer',
    _a[Prior_Authorization_Status_Requester.Pharmacy] = 'Pharmacy',
    _a[Prior_Authorization_Status_Requester.Provider] = 'Provider',
    _a);
export var PriorAuthorizationStatusRequesterEnum = {
    name: 'PriorAuthorizationStatusRequester',
    enumValues: enumValuesFactory(enumDescriptionMap)
};
